import { useState, useEffect } from 'react';
import axios from 'axios';
import { useIntl } from 'react-intl'
import { ExamResult, ProgramQuota } from './_models'
import { useAuth } from '../../modules/auth/core/Auth';
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { languages } from 'prismjs';


const API_URL_REAL = process.env.REACT_APP_API_URL


interface PreferenceFormProps {
    period: any;
}


const PreferenceForm = ({ period }: PreferenceFormProps) => {
    const [examResults, setExamResults] = useState<ExamResult[]>([]);
    const [selectedExamResult, setSelectedExamResult] = useState<ExamResult | null>(null);
    const [programQuotas, setProgramQuotas] = useState<ProgramQuota[]>([]);
    const [selectedQuotas, setSelectedQuotas] = useState<(ProgramQuota | null)[]>([null, null, null, null, null]);
    const [warning, setWarning] = useState<string | null>(null);
    const intl = useIntl()
    const lang = useLang()
    const { currentUser } = useAuth()

    const navigate = useNavigate();
    useEffect(() => {
        const fetchWarning = async () => {
            try {
                const response = await axios.get(`${API_URL_REAL}/Custom/GetQuestionWarning`);

                if (response.data !== "NoDescription") {
                    lang === "tr" ? setWarning(response.data.warningDescription) : setWarning(response.data.warningDescriptionEn);

                }

            } catch (error) {
                console.error(error);
            }
        };

        fetchWarning();


        axios.get(`${API_URL_REAL}/Custom/GetExamResults`).then((res) => {
            setExamResults(res.data);
            function showErrorAndRedirect() {
                Swal.fire({
                    title: intl.formatMessage({
                        id: 'Error'
                    }),
                    text: intl.formatMessage({
                        id: 'You dont have an approved exam score to continue'
                    }),
                    icon: 'error',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' }),
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(() => {
                    navigate('/dashboard')
                });
            }

            const approvedData = res.data.filter((er: any) => er.isApproved);

            if (approvedData.length === 0) {
                showErrorAndRedirect();
                return;
            }

            if (!approvedData.some((er: any) => er.adjustedScore >= 200)) {
                showErrorAndRedirect();
                return;
            }

        });



        axios.get(`${API_URL_REAL}/Custom/GetProgramsForPreference`, {
            params: {
                preferencePeriodId: period.id
            }
        }).then((res) => {
            setProgramQuotas(res.data);
        });

        const fetchPreferences = async () => {
            try {
                const response = await axios.get<ProgramQuota[]>(`${API_URL_REAL}/Custom/GetPreferences`, {
                    params: {
                        preferencePeriodId: period.id
                    }
                });
                //console.log(response)

                // Get the preferences from the response
                const preferences = response.data;

                // Create a new array with the preferences and any remaining null values
                const newSelectedQuotas = [...preferences, ...new Array(5 - preferences.length).fill(null)];
                setSelectedQuotas(newSelectedQuotas);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPreferences();
    }, []);

    return (
        <div>
            {warning && (
                <div className="alert alert-danger">
                    {warning}
                </div>
            )}

            <ExamResultDropdown
                examResults={examResults}
                selectedExamResult={selectedExamResult}
                setSelectedExamResult={setSelectedExamResult}
            />

            <Quotas
                programQuotas={programQuotas}
                selectedQuotas={selectedQuotas}
                setSelectedQuotas={setSelectedQuotas}
                period={period}
                selectedExamId={selectedExamResult?.id || 0}
            />
            {/* Rest of the form elements */}
        </div>
    );
};

const ExamResultDropdown = ({
    examResults,
    selectedExamResult,
    setSelectedExamResult,
}: {
    examResults: ExamResult[];
    selectedExamResult: ExamResult | null;
    setSelectedExamResult: (examResult: ExamResult | null) => void;
}) => {

    const intl = useIntl();
    return (
        // <div className="mb-3">
        //     <label htmlFor="examResultSelect" className="form-label">{
        //         intl.formatMessage({
        //             id: 'Select Exam Result To Be Calculated On Placements'
        //         })
        //     }
        //     </label>
        //     <select
        //         id="examResultSelect"
        //         className="form-select"
        //         value={selectedExamResult?.id}
        //         onChange={(e) =>
        //             setSelectedExamResult(
        //                 examResults.find((er) => er.id.toString() === e.target.value) || null
        //             )
        //         }
        //     >
        //         <option value="">Seçiniz</option>
        //         {examResults.map((er) => (
        //             <option value={er.id} disabled={!er.isApproved || er.adjustedScore < 200}>
        //                 {er.examType} - {er.adjustedScore}
        //                 {intl.formatMessage({
        //                     id: er.isApproved ? ' ' :
        //                         'Approval pending'
        //                 })}
        //                 {intl.formatMessage({
        //                     id: er.adjustedScore >= 200 ? ' ' :
        //                         'Bellow Required Score 200'
        //                 })}
        //             </option>
        //         ))}
        //     </select>
        // </div>
        <></>
    );
};
const Quotas = ({
    programQuotas,
    selectedQuotas,
    setSelectedQuotas,
    period,
    selectedExamId,
}: {
    programQuotas: ProgramQuota[];
    setSelectedQuotas: React.Dispatch<React.SetStateAction<(ProgramQuota | null)[]>>;
    selectedQuotas: (ProgramQuota | null)[];
    period: any;
    selectedExamId: number;
}) => {

    const handleChange = (index: number, id: number) => {
        setSelectedQuotas((oldQuotas) => {
            const newQuotas = [...oldQuotas];
            // Eğer seçim yapılmıyorsa, bu seçimden sonraki tüm seçimleri sıfırla
            if (id === 0) {
                newQuotas.fill(null, index);
            } else {
                newQuotas[index] = programQuotas.find((pq) => pq.id === id) || null;
            }
            return newQuotas;
        });
    };

    const lang = useLang()
    const intl = useIntl();
    // ...

    const handleSave = async () => {

        // if (selectedExamId === 0) {
        //     Swal.fire({
        //         title: intl.formatMessage({
        //             id: 'Error'
        //         }),
        //         text: intl.formatMessage({
        //             id: 'To save, you need to select at least one exam score.'
        //         }),
        //         icon: 'error',
        //         confirmButtonText: intl.formatMessage({ id: 'Okay' })
        //     });
        //     return;
        // }

        // ...tercihleri kaydet
        if (selectedQuotas.every(sq => sq === null)) {
            Swal.fire({
                title: intl.formatMessage({
                    id: 'Error'
                }),
                text: intl.formatMessage({
                    id: 'To save, you need to select at least one program.'
                }),
                icon: 'error',
                confirmButtonText: intl.formatMessage({ id: 'Okay' })
            });
            return;
        }

        // Kullanıcıya uyarı ver ve onayını al
        let result = await Swal.fire({
            title: intl.formatMessage({
                id: 'preferenceWarning'
            }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({ id: 'iAccept' }),
            cancelButtonText: intl.formatMessage({ id: 'Cancel' }),
            width: '600px',

        });

        // Kullanıcı onay vermediyse, işlemi sonlandır
        if (!result.isConfirmed) {
            return;
        }

        // Onay verildiyse, tercihleri kaydetmeye devam et
        try {
            const newPreferences = selectedQuotas.map((quota, index) => ({
                ProgramQuotaId: quota?.id,
                PreferenceRanking: index + 1 // 'index', 0'dan başladığı için 1 ekliyoruz
            }));

            const response = await axios.post(`${API_URL_REAL}/Custom/SavePreferences`, newPreferences, {
                params: {
                    preferencePeriodId: period.id,
                    lang: lang === "tr" ? "tr" : "en"
                    // activeExamResultId: selectedExamId,
                }
            });
            // İsteğin durumuna göre bir Swal mesajı göster
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({
                        id: 'Success'
                    }),
                    text: intl.formatMessage({ id: 'Your preferences have been saved. You can make changes to your preferences until the last day of the calendar.' }),
                });
            }
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || 'There is an error occurred. Please try again.';
            setSelectedQuotas([null, null, null, null, null])
            Swal.fire({
                icon: 'error',
                title: intl.formatMessage({
                    id: 'Error'
                }),
                text: errorMessage,
            });
        }
    };

    return (
        <div className='mt-10'>
            {selectedQuotas.map((_, index) => (
                <div className="mb-5" key={index}>
                    <label htmlFor={`preference${index}`} className="form-label">
                        {intl.formatMessage({ id: 'Preference' })}{` ${index + 1}`}
                    </label>
                    <select
                        id={`preference${index}`}
                        className="form-select"
                        value={selectedQuotas[index]?.id || ''}
                        onChange={(e) => handleChange(index, Number(e.target.value))}
                        disabled={index > 0 && !selectedQuotas[index - 1]} // Bir önceki tercih yapılmadan, mevcut tercih etkinleştirilmez.
                    >
                        <option value="">{intl.formatMessage({ id: 'Select a program' })}...</option>
                        {programQuotas.map((pq) => (
                            <option
                                value={pq.id}
                                key={pq.id}
                                disabled={pq.quota <= 0 || selectedQuotas.some((sq) => sq?.id === pq.id && index !== selectedQuotas.indexOf(sq))}
                            >
                                {`${pq.organizationName} / ${pq.programName} (${intl.formatMessage({ id: 'Quota' })}: ${pq.quota})`}
                            </option>
                        ))}
                    </select>
                    {/* {selectedQuotas[index]?.minPoint && selectedQuotas[index]?.minPoint != 0 && selectedQuotas[index]?.minPoint !== null && (
                        <div
                            className="alert alert-primary mt-4"
                            dangerouslySetInnerHTML={{
                                __html: `${intl.formatMessage({ id: 'Min_Tryos_Score' })}: ${selectedQuotas[index]?.minPoint}`
                            }}
                        />
                    )} */}
                    {
                        selectedQuotas[index]?.minPoint && selectedQuotas[index]?.minPoint != 0 && selectedQuotas[index]?.minPoint !== null
                            ? (
                                <div
                                    className="alert alert-primary mt-4"
                                    dangerouslySetInnerHTML={{
                                        __html: `${intl.formatMessage({ id: 'Min_Tryos_Score' })}: ${selectedQuotas[index]?.minPoint}`
                                    }}
                                />
                            )
                            : null
                    }


                    {selectedQuotas[index]?.text && (
                        <div
                            className="alert alert-primary mt-2"
                            dangerouslySetInnerHTML={{
                                __html: (lang === "tr" ? selectedQuotas[index]?.text : selectedQuotas[index]?.textEn) || ""
                            }}
                        />
                    )}

                </div>
            ))}
            <button className="btn btn-primary mt-3" onClick={handleSave}>
                {intl.formatMessage({ id: 'Save my preferences' })}
            </button>
        </div>
    );
}


export default PreferenceForm;
